import type { RestClient } from "./restClient";

export interface OnboardingContext {
  industry: string | null;
  role: string | null;
  intents: string[];
  raw_data: Record<string, unknown>;
  tools_completed: boolean;
}

export interface OnboardingContextResponse {
  context: OnboardingContext | null;
  recommended_connectors: string[];
}

export class OnboardingApi {
  constructor(private client: RestClient) {}

  /** Save onboarding context for the company (upsert). */
  postContext(params: {
    industry?: string | null;
    role?: string | null;
    intents?: string[];
    raw_data?: Record<string, unknown>;
    tools_completed?: boolean;
  }): Promise<{ ok: boolean }> {
    return this.client.post("/v1/onboarding/context", params);
  }

  /** Read onboarding context + recommended connectors. */
  getContext(): Promise<OnboardingContextResponse> {
    return this.client.get("/v1/onboarding/context");
  }
}
